// shipService.ts
import { HubConnection } from '@microsoft/signalr';
import { errorService } from './errorService';
import { normalizeShipDto } from '../types/ship-types';
import type { ShipDto } from '../types/ship-types';

export async function warpShip(connection: HubConnection, playerId: string, shipId: string): Promise<ShipDto> {
  try {
    // Hub returns { Message: string }, NOT ShipDto.
    // We might need to fetch the ship or game state after.
    // Or update Hub to return ShipDto.
    // The original controller returned { Message: string } for WarpShipToBelt?
    // Let's check ShipController.cs
    // ShipController.WarpShipToBelt returned Ok(new { Message = ... });
    // So the original service was returning { Message: ... } but typed as ShipDto?
    // Wait, the original service: return normalizeShipDto(result);
    // normalizeShipDto expects ShipDto.
    // If controller returned { Message }, then normalizeShipDto might be failing or doing nothing.
    // Actually, ShipController.WarpShipToBelt returned Ok(new { Message ... }).
    // So the frontend was probably ignoring the return value or it was typed loosely.
    // But here it says Promise<ShipDto>.
    // Let's assume we just return what Hub returns for now, but type it as any or object.
    // Actually, let's check if we can return ShipDto from Hub.
    // GameHub.WarpShipToBelt returns object.
    // I should probably update GameHub to return ShipDto if the frontend expects it.
    // But for now, let's match the backend behavior.
    const result = await connection.invoke('WarpShipToBelt', playerId, shipId, null);
    return result as any;
  } catch (error) {
    if (!(error instanceof Error && error.message.includes('Failed to warp ship'))) {
      errorService.addError(`Network error while warping ship: ${error instanceof Error ? error.message : 'Unknown error'}`, 0);
    }
    throw error;
  }
}

export async function recallShip(connection: HubConnection, playerId: string, shipId: string): Promise<ShipDto> {
  try {
    const result = await connection.invoke('RecallShip', playerId, shipId);
    return result as any;
  } catch (error) {
    if (!(error instanceof Error && error.message.includes('Failed to recall ship'))) {
      errorService.addError(`Network error while recalling ship: ${error instanceof Error ? error.message : 'Unknown error'}`, 0);
    }
    throw error;
  }
}

export async function purchaseUpgrade(connection: HubConnection, playerId: string, shipId: string, branchType: string | number, upgradeName: string): Promise<ShipDto> {
  try {
    // GameHub.UpgradeShip returns ShipDto.
    const result = await connection.invoke('UpgradeShip', playerId, shipId, branchType, upgradeName);
    return normalizeShipDto(result);
  } catch (error) {
    if (!(error instanceof Error && error.message.includes('Failed to purchase upgrade'))) {
      errorService.addError(`Network error while purchasing upgrade: ${error instanceof Error ? error.message : 'Unknown error'}`, 0);
    }
    throw error;
  }
}

export async function buildShip(connection: HubConnection, playerId: string, type: string | number): Promise<ShipDto> {
  try {
    // GameHub.BuildShip returns { Message, OreCost }.
    const result = await connection.invoke('BuildShip', playerId, type);
    return result as any;
  } catch (error) {
    if (!(error instanceof Error && error.message.includes('Failed to build ship'))) {
      errorService.addError(`Network error while building ship: ${error instanceof Error ? error.message : 'Unknown error'}`, 0);
    }
    throw error;
  }
}

export async function recycleShip(connection: HubConnection, playerId: string, shipId: string): Promise<any> {
  try {
    const result = await connection.invoke('RecycleShip', playerId, shipId);
    return result;
  } catch (error) {
    if (!(error instanceof Error && error.message.includes('Failed to recycle ship'))) {
      errorService.addError(`Network error while recycling ship: ${error instanceof Error ? error.message : 'Unknown error'}`, 0);
    }
    throw error;
  }
}
